import React, { Component } from 'react';
import { credentials } from '@shootsta/client-auth';
import cx from 'classnames';
import Files from 'react-files';
import { Icon } from '../../../../../ui-kit';
import { AssetSelector } from '../../../../Uploader';
import Asset from './Asset';

import '../styles/_comment-assets.scss';














class CommentAssets extends Component {


  handleFilesChange = async (passedFiles) => {
    const { onFilesChange } = this.props;

    if (!passedFiles.length) {
      return;
    }

    const { addFileToQueue, assetIds } = this.props;

    const newAssetIds = await Promise.all(
      passedFiles.map((file) => addFileToQueue({ file }))
    );

    this._filePickerRef.removeFiles();

    onFilesChange([...assetIds, ...newAssetIds]);
  };

  setFilePickerRef = (ref) => {
    if (this._filePickerRef || !ref) {
      return;
    }

    this._filePickerRef = ref;
  };

  deleteAsset = (index) => (e) => {
    const { updateComment, assetIds, commentId, onFilesChange } = this.props;

    e.stopPropagation();

    const newAssetIds = [...assetIds];

    newAssetIds.splice(index, 1);

    onFilesChange(newAssetIds);

    if (!commentId) {
      return;
    }

    updateComment(commentId, { assetIds: newAssetIds });
  };

  render() {
    const { assetIds, canAdd, canDelete, isV2Design } = this.props;
    const {
      user: { isAnonymous }
    } = { user: {}, ...credentials.get() };
    const canAddAssets = canAdd && !isAnonymous;

    return (
      <div
        className={cx('comment-assets', {
          'comment-assets__container': Boolean(assetIds.length)
        })}>

        {assetIds.map((assetId, index) =>
        <AssetSelector key={assetId} assetId={assetId}>
            {(asset) => {
            if (!asset) {
              return (
                <Icon
                  className="comment-assets__deleted"
                  name="corrupt"
                  size={25}
                  color="michael" />);


            }

            return (
              <Asset
                isV2Design={isV2Design}
                asset={asset}
                deleteAsset={canDelete && this.deleteAsset(index)} />);


          }}
          </AssetSelector>
        )}
        {canAddAssets &&
        <Files
          onChange={this.handleFilesChange}
          accepts={[
          'image/*',
          'video/*',
          'audio/*',
          '.pdf',
          '.doc',
          '.docx',
          '.ppt',
          '.pptx',
          '.rtf',
          '.zip',
          '.rar',
          '.xls',
          '.xlsx',
          '.svg',
          '.csv',
          '.txt']}

          minFileSize={1}
          clickable
          ref={this.setFilePickerRef}
          multiple>

            <Icon
            name="attachment"
            size={20}
            onClick={Function.prototype}
            hoverColor="black"
            color="denim"
            className="comment-assets__placeholder" />

          </Files>}

      </div>);

  }
}

export default CommentAssets;